module.exports = __webpack_public_path__ + "resources/img/bg_cover_solution_m.9f18bd3110745127984c4594eb01f1da.png";